import { PaginadoTareas, Tarea } from '../../pages/tareas/models'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'
import { TareaCompletada } from '../../pages/tareas/models'

export const tareasApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP del modulo Tareas.
     * Cubre listados, detalle, tareas relacionadas y operaciones de escritura.
     */
    recuperarTareas: builder.query<
      PaginadoTareas,
      { pagina: number; registrosPorPagina: number; nombre?: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_TAREAS}`,
          params: keysToSnake(arg),
        }
      },
    }),

    recuperarTareaporId: builder.query<Tarea, string>({
      query: (idTarea) => `${window._env_.API_CONTEXTO_TAREAS}/${idTarea}`,
    }),

    /**
     * Consulta tareas asociadas a autorizaciones o condicionantes usando el ID relacionado.
     */
    recuperarTareasPorIdRelacionado: builder.mutation({
      query(idRelacionado) {
        return {
          method: 'GET',
          url: `${window._env_.API_CONTEXTO_TAREAS}/relacionado/${idRelacionado}`,
        }
      },
    }),

    recuperarTareasPorIdRelacionadoCardTarea: builder.mutation({
      query: (idRelacionado) => {
        return {
          url: `${window._env_.API_CONTEXTO_TAREAS}/relacionado/${idRelacionado}`,
          method: 'GET',
        }
      },
    }),
    guardarTarea: builder.mutation({
      query: (tarea) => ({
        url: `${window._env_.API_CONTEXTO_TAREAS}/`,
        method: 'POST',
        body: keysToSnake(tarea),
      }),
    }),

    actualizarTarea: builder.mutation({
      query: ({ idTarea, ...tarea }) => {
        return {
          url: `${window._env_.API_CONTEXTO_TAREAS}/${idTarea}`,
          method: 'PUT',
          body: keysToSnake(tarea),
        }
      },
    }),

    eliminarTareaPorId: builder.mutation({
      query: (idTarea) => {
        return {
          url: `${window._env_.API_CONTEXTO_TAREAS}/${idTarea}`,
          method: 'DELETE',
        }
      },
    }),

    recuperarComentariosTareas: builder.query<TareaCompletada, string>({
      query: (idTarea) => `${window._env_.API_CONTEXTO_TAREAS}/${idTarea}/comentario`,
    }),
  }),
})

export const {
  useRecuperarTareasQuery,
  useRecuperarTareaporIdQuery,
  useRecuperarTareasPorIdRelacionadoMutation,
  useGuardarTareaMutation,
  useActualizarTareaMutation,
  useEliminarTareaPorIdMutation,
  useRecuperarComentariosTareasQuery,
} = tareasApi
